<sm-confirmation-dialog
  class="sm-backend-recovery-banner"
  [isOpen]="true"
  panelVariant="form"
  [title]="title"
  [description]="description"
  [confirmationText]="''"
  [confirmLabel]="retryLabel"
  [showCloseButton]="false"
  [showCancelButton]="false"
  [backdropDismiss]="false"
  [confirmDisabled]="checking"
  [heroIconName]="'warning-outline'"
  [contentAlign]="'center'"
  (confirmRequest)="retryRequested.emit()">
  <p class="sm-backend-recovery-banner__countdown" role="status">{{ countdownText }}</p>
  <ion-progress-bar
    class="sm-backend-recovery-banner__progress"
    [attr.aria-label]="progressAriaLabel"
    [type]="checking ? 'indeterminate' : 'determinate'"
    [value]="progressValue">
  </ion-progress-bar>
</sm-confirmation-dialog>
